module.exports = __webpack_public_path__ + "img/henry_bw.71dd5fe1.jpg";